<script setup lang="ts">
// import { updateMeditationRoom } from '@/api/meditation';
import BaseModal from '@/components/modal/BaseModal.vue';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';
import MeditationRoomModalRadioLabelRow from '@/components/radio/MeditationRoomModalRadioLabelRow.vue';
import { IMindShareChoiceRoomModalProps, useModalStore } from '@/stores/modal';
import { IMeditationRoom } from '@/types/meditation';
import { ref, watch, computed } from 'vue';

const props = defineProps<IMindShareChoiceRoomModalProps>();
const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'open-nested-modal', type: string, props: any): void;
  (e: 'close-nested-modal'): void;
  (e: 'update:meditationRoomList', meditationRoomList: IMeditationRoom[]): void;
}>();

const modalStore = useModalStore();

const isSubmitting = ref(false);
const selectedRoomId = ref<number>(0);

const meditationRoomList = computed(() => {
  return [...props.meditationRoomList].sort((a, b) => a.id - b.id);
});
// console.log('meditationRoomList', meditationRoomList.value);

const handleClose = () => {
  modalStore.close();
};

const convertDisplayLabel = (item: IMeditationRoom) => {
  return `${item.title} (${item.time})`;
};

const handleConfirm = () => {
  modalStore.close();
  props.onConfirm(selectedRoomId.value);
};

const handleNestedEditConfirmClick = (mode: 'edit' | 'create', selectedRoomItem: Partial<IMeditationRoom>) => {
  isSubmitting.value = true;
  props.nestedOnConfirm(mode, selectedRoomItem);

  setTimeout(() => {
    isSubmitting.value = false;
  }, 300);
  emit('close-nested-modal');
};

/* 관리자 수정 , 나누기방 추가 클릭시*/
const handleOpenNestedModal = (modalType: string, modalProps: any) => {
  emit('open-nested-modal', modalType, modalProps);
};

const handleDeleteMeditationRoom = (id: number) => {
  isSubmitting.value = true;
  props.deleteOnConfirm(id);
  setTimeout(() => {
    isSubmitting.value = false;
  }, 300);
};

onMounted(() => {
  if (props.type === 'user' && props.selectedRoomItem) {
    selectedRoomId.value = props.selectedRoomItem.id;
  }
});
</script>

<template>
  <BaseModal
    :title="props.type === 'user' ? '구글미트 나누기방 선택하기' : '나누기방 목록'"
    width="360px"
    @close="handleClose"
  >
    <div class="flex flex-col gap-1 max-h-[600px] px-3 overflow-y-auto">
      <MeditationRoomModalRadioLabelRow
        v-for="option in meditationRoomList"
        :key="option?.id"
        v-model="selectedRoomId"
        :value="option?.id"
        :label="convertDisplayLabel(option)"
        :type="props.type"
        :selectedRoomItem="option"
        :onConfirm="handleNestedEditConfirmClick"
        :deleteOnConfirm="handleDeleteMeditationRoom"
        name="meetingTime"
        @open-nested-modal="handleOpenNestedModal"
        @click.stop
      />
    </div>

    <p v-if="props.type === 'user'" class="text-xs text-[##878787] mt-2 mb-8 text-right">
      * 나누기방은 재설정 할 수 있습니다.
    </p>
    <p
      v-else
      class="text-[16px] font-bold text-[#519EA6] mt-4 mb-8 text-left cursor-pointer pl-4"
      @click="
        handleOpenNestedModal('nested-mindshare-edit', {
          mode: 'create',
          selectedRoomItem: null,
          onConfirm: handleNestedEditConfirmClick,
        })
      "
    >
      + 나누기방 추가
    </p>
    <template #footer>
      <ModalFooterConfirmButtons
        cancel-text="취소"
        confirm-text="설정하기"
        :is-loading="isSubmitting"
        :disabled="!selectedRoomId"
        @cancel="handleClose"
        @confirm="handleConfirm"
      />
    </template>
  </BaseModal>
</template>
